import React, { useRef } from 'react';
import { Link, NavLink } from "react-router-dom";
import Logo from "../../../assets/img/taskde-whitelogo.svg";
import ScrollToTop from "react-scroll-to-top";
import { useEffect } from 'react';
import { RiFacebookFill, RiInstagramFill, RiLinkedinBoxFill, RiTwitterXFill } from 'react-icons/ri';
import { useState } from 'react';
import { getTaskCategoryList } from '../../../Redux/Task/action';

const Footer = ({ scrollToTop }) => {

    const [category, setCategory] = useState();
    useEffect(() => {
        getTaskCategoryList()((response) => {
            if (response && response.status) {
                setCategory(response?.data?.data)
            }


        });
    }, []);


    return (
        <React.Fragment>
            <footer id="footer" className="footer">
                <div className="footer-top">
                    <div className="container">
                        <div className="row gy-4">
                            <div className="col-lg-5 col-md-12 footer-info">
                                <NavLink to="/" className="logo d-flex align-items-center">
                                    <img src={Logo} className="img-fluid" alt="" />
                                </NavLink>
                                <p>Taskde is a marketplace solution for your everyday needs. Be it tax, astrology, digit or heal. We have it covered !
                                </p>
                                <div className="social-links mt-3">
                                    <a href="https://twitter.com/Taskdepvtltd" target="_blank" rel="noreferrer"><RiTwitterXFill size={18} /></a>
                                    <a href="https://www.facebook.com/people/Taskde-Private-Limited/100088719511852/" target="_blank" rel="noreferrer"><RiFacebookFill /> </a>
                                    {/* <a href="" target="_blank" rel="noreferrer"><RiInstagramFill /></a> */}
                                    <a href="https://www.linkedin.com/in/taskde-private-limited-106a43259/" target="_blank" rel="noreferrer"><RiLinkedinBoxFill /></a>
                                </div>
                            </div>
                            <div className="col-lg-2 col-6 footer-links">
                                <h4>Quick Links</h4>
                                <ul>
                                    <li><i className="bi bi-chevron-right"></i> <a href="/">Home</a></li>
                                    <li><i className="bi bi-chevron-right"></i> <NavLink to="/aboutus">About us</NavLink></li>
                                    <li><i className="bi bi-chevron-right"></i> <NavLink to="/termsofservices">Terms of service</NavLink></li>
                                    <li><i className="bi bi-chevron-right"></i> <NavLink to="/privacypolicy">Privacy policy</NavLink></li>
                                    <li><i className="bi bi-chevron-right"></i> <NavLink to="/return-refund-policy">Refund and Return Policy</NavLink></li>
                                </ul>
                            </div>
                            <div className="col-lg-2 col-6 footer-links">
                                <h4>Our Services</h4>
                                <ul>
                                    {category?.map((catgry, index) =>
                                        <li key={index}><i className="bi bi-chevron-right"></i>
                                            <Link
                                                to={localStorage.getItem("user_type") === "1" ? '/services' : (localStorage.getItem("user_type") === "2" ? '/' : '/signin')}
                                                state={{ category_id: catgry.id }}
                                                onClick={scrollToTop}
                                            >
                                                {catgry?.name}
                                            </Link>
                                        </li>
                                    )}
                                    {/* <li><i className="bi bi-chevron-right"></i>
                                        <NavLink to={localStorage.getItem("user_type") && localStorage.getItem("user_type") == 1 ? '/services' : '/signin'} onClick={scrollToTop}>Digital</NavLink>
                                    </li>
                                    <li><i className="bi bi-chevron-right"></i>
                                        <NavLink to={localStorage.getItem("user_type") && localStorage.getItem("user_type") == 1 ? '/services' : '/signin'} onClick={scrollToTop}>Astro</NavLink>
                                    </li>
                                    <li><i className="bi bi-chevron-right"></i>
                                        <NavLink to={localStorage.getItem("user_type") && localStorage.getItem("user_type") == 1 ? '/services' : '/signin'} onClick={scrollToTop}>Heal</NavLink>
                                    </li> */}

                                    {/* <li><i className="bi bi-chevron-right"></i> <NavLink to="/services">Digital</NavLink></li>
                                    <li><i className="bi bi-chevron-right"></i> <NavLink to="/services">Astro</NavLink></li>
                                    <li><i className="bi bi-chevron-right"></i> <NavLink to="/services">Heal</NavLink></li> */}
                                    {/* <li><i className="bi bi-chevron-right"></i> <NavLink to="/">Learn </NavLink></li> */}
                                </ul>
                            </div>
                            <div className="col-lg-3 col-md-12 footer-contact text-md-start">
                                <h4>Contact Us</h4>
                                <p>
                                    Taskde Private Limited <br></br>
                                    655G, Maruti Bhawan, Basaratpur, Gorakhpur <br></br>
                                    India, Uttar Pradesh - 273004 <br></br>
                                    <strong><i className="bi bi-phone"></i> Phone:</strong> <a href='tel:05514025324'> 05514025324 </a> <br></br>
                                    <strong><i className="bi bi-envelope"></i> Email:</strong><a href='mailto:support@taskde.com'> support@taskde.com</a><br></br>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="copyright">
                                Copyright &copy; 2022 Taskde. All Rights Reserved
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="designed">
                                Designed & Developed by <a href="https://www.aventusinformatics.com/" target="_blank" rel="noopener noreferrer">Aventus Informatics</a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

            <ScrollToTop smooth top="1000" color="#fff" width="18" height="18" style={{ backgroundColor: "#264796", bottom: "60px" }} />
        </React.Fragment>
    )
}

export default Footer;